import React from 'react';
import { Link } from 'react-router-dom';
import PublicShell from './PublicShell';
import './TrustLayout.css';

/**
 * Shared layout for Privacy / Security / Terms / Support / Status.
 * Sidebar of siblings + long-form content area. Deliberately plain —
 * buyers scan these pages for signal, not design.
 */

const TRUST_LINKS = [
  { to: '/privacy', label: 'Privacy' },
  { to: '/security', label: 'Security' },
  { to: '/terms', label: 'Terms' },
  { to: '/support', label: 'Support' },
  { to: '/status', label: 'Status' }
];

export default function TrustLayout({ title, eyebrow, lastUpdated, children }) {
  return (
    <PublicShell>
      <div className="trust">
        <aside className="trust__sidebar" aria-label="Trust pages">
          <h2 className="trust__sidebar-title">Trust</h2>
          <nav className="trust__sidebar-nav">
            {TRUST_LINKS.map(link => (
              <Link key={link.to} to={link.to} className="trust__sidebar-link">
                {link.label}
              </Link>
            ))}
          </nav>
        </aside>

        <article className="trust__article">
          {eyebrow && <span className="trust__eyebrow">{eyebrow}</span>}
          <h1 className="trust__title">{title}</h1>
          {lastUpdated && (
            <p className="trust__meta">Last updated {lastUpdated}</p>
          )}
          <div className="trust__body">{children}</div>
        </article>
      </div>
    </PublicShell>
  );
}
